// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BasicEnrollmentSurveyAnswer } from './basicEnrollmentSurveyAnswer.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BasicEnrollmentSurveyQuestion {
    'key': string;
    'answers': Array<BasicEnrollmentSurveyAnswer>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BasicEnrollmentSurveyQuestion>> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "answers",
            "baseName": "answers",
            "type":     "Array<BasicEnrollmentSurveyAnswer>"
        },
    ];

    static getAttributeTypeMap() {
        return BasicEnrollmentSurveyQuestion.attributeTypeMap;
    }
}
